/* ducks-n-stuff — product gallery.

   Two jobs:
   1. Swap the framed stage image when a thumbnail is chosen.
   2. Follow the selected variant: swap the image, move the thumbnail ring, and
      flag the section when the variant is sold out so the Shop Pay button hides.

   Craft's product-info.js only knows its own <media-gallery>; this gallery is
   ours, so Craft never touches it (product-info.js carries a null-guard for
   that). Craft also never re-renders the accelerated-checkout button on a
   variant change, which is why availability is handled here by class rather
   than by Liquid at render time. */
(function () {
  /* ---------- thumbnails ---------- */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-dns-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-dns-gallery]');
    if (!gallery) return;
    setStage(gallery, { full: thumb.dataset.full, srcset: thumb.dataset.srcset, alt: thumb.dataset.alt });
    markActive(gallery, thumb);
  });

  function setStage(gallery, media) {
    var stage = gallery.querySelector('[data-dns-stage-image]');
    if (!stage || !media || !media.full) return;
    if (stage.getAttribute('src') === media.full) return;
    stage.src = media.full;
    stage.srcset = media.srcset || '';
    stage.alt = media.alt || '';
  }

  /* Pass null to clear the ring: the shown photo may not be one of the eight
     thumbnails, and a stale ring on the wrong thumbnail is worse than none. */
  function markActive(gallery, thumb) {
    gallery.querySelectorAll('[data-dns-thumb]').forEach(function (other) {
      other.classList.toggle('is-active', other === thumb);
    });
  }

  /* ---------- variant changes ---------- */
  var info = document.querySelector('product-info');
  var gallery = document.querySelector('[data-dns-gallery]');
  if (!info || !gallery) return;

  var mapNode = document.querySelector('[data-dns-variant-media]');
  var map = {};
  try { map = JSON.parse((mapNode && mapNode.textContent) || '{}'); } catch (e) { return; }
  if (!Object.keys(map).length) return;

  function currentVariantId() {
    var input = info.querySelector('[name="id"]');
    return input ? String(input.value || '') : '';
  }

  function setStockNote(inStock) {
    var note = info.querySelector('[data-dns-stock-note]');
    if (!note) return;
    var text = note.getAttribute(inStock ? 'data-in-stock' : 'data-sold-out');
    if (text != null && note.textContent.trim() !== text) note.textContent = text;
  }

  function apply(id) {
    var v = map[id];
    if (!v) return;
    info.classList.toggle('dns-variant-unavailable', v.available === false);
    setStockNote(v.available !== false);
    if (!v.full) return; /* variant carries no image of its own: keep what is showing */
    setStage(gallery, v);
    markActive(gallery, gallery.querySelector('[data-dns-thumb][data-media-id="' + v.mediaId + '"]'));
  }

  var lastId = currentVariantId();
  apply(lastId); /* the class is also rendered server-side; this keeps them in step */

  function sync() {
    var id = currentVariantId();
    if (!id || id === lastId) return;
    lastId = id;
    apply(id);
  }

  /* Craft rewrites the hidden id input during its partial re-render, and an
     input's value changing fires no event of its own, so watch the subtree. */
  new MutationObserver(sync).observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'selected', 'checked'] });
  info.addEventListener('change', function () { setTimeout(sync, 0); });
})();
